import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { analytics } from '../../services/analytics';
import SEOPageLayout from '../../components/SEOPageLayout';

const QuoteTracking = () => {
  useEffect(() => {
    analytics.track('Feature Page View', { feature: 'Quote Tracking' });
  }, []);

  return (
    <SEOPageLayout
      title="Quote Tracking & Analytics - Know When They Look | QuoteTier"
      description="Stop guessing. Get notified the instant a client opens your quote. See how long they look and what they interact with."
      canonical="/features/quote-tracking-analytics"
      ogTitle="Read Your Client's Mind"
      ogDescription="Know exactly when to follow up. Our tracking tells you when they open it, how many times they view it, and if they forwarded it."
    >
      <section className="py-32 md:py-40 lg:py-48">
        <div className="container max-w-7xl mx-auto px-4">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="font-instrument text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight leading-tight mb-6">
              Stop Sending Quotes into a <span className="text-primary font-bold">Black Hole</span>
            </h1>
            <p className="font-jetbrains text-xl md:text-2xl text-gray-600 tracking-tight leading-relaxed mb-8">
              Get real-time alerts when clients view your proposal. call them while you're top of mind.
            </p>
            <div className="font-instrument mt-12 flex flex-col sm:flex-row gap-6 justify-center items-center mb-6">
              <Link to="/signup">
                <Button className="px-8 py-4 text-xl font-semibold bg-black text-white hover:bg-gray-800 rounded-lg shadow-lg">
                  Start Tracking Quotes
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-4">Actionable Insights</h2>
          </div>

          <div className="grid gap-6 md:grid-cols-3">
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Instant Notifications</CardTitle></CardHeader>
              <CardContent><p className="font-jetbrains text-sm text-gray-600">Receive an email or push notification the second they click the link. Perfect timing for a follow-up call.</p></CardContent>
            </Card>
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Engagement Metrics</CardTitle></CardHeader>
              <CardContent><p className="font-jetbrains text-sm text-gray-600">See how many times they've opened it. Multiple opens usually mean they are comparing or discussing it seriously.</p></CardContent>
            </Card>
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Deal Health</CardTitle></CardHeader>
              <CardContent><p className="font-jetbrains text-sm text-gray-600">Identify "ghosted" quotes that haven't been opened in weeks vs. hot leads that are active right now.</p></CardContent>
            </Card>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-black text-white">
        <div className="container max-w-4xl mx-auto px-4 text-center">
          <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-6">Close Deals Faster with Data</h2>
          <Link to="/signup">
            <Button className="px-10 py-4 font-instrument text-xl font-semibold bg-white text-black hover:bg-gray-200 rounded-lg shadow-lg">
              Start Free
            </Button>
          </Link>
        </div>
      </section>
    </SEOPageLayout>
  );
};

export default QuoteTracking;
